import styled from 'styled-components'
import { colors } from '../../../lib/colors'
import { REPLY_STYLED_PROPS } from '../interface'

export const PlaceHolder = styled.div`
  position: relative;
  width: 55px;
  height: 80px;
  text-align: center;
  background: ${colors.primaryLight};
  border-radius: 8px;
  margin: 5px;
`

export const CardWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Cardback = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
  border-radius: 8px;
  background-color: ${colors.cardBack};
`

export const CardFront = styled.div<REPLY_STYLED_PROPS>`
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
  border-radius: 8px;
  background-color: ${({ background }) => background || colors.cardWhite};
  padding-top: 14px;
  p {
    line-height: 24px;
    font-size: 24px;
    color: ${({ suitColor }) => suitColor};
  }
  svg {
    position: absolute;
    right: 50%;
    transform: translateX(50%);
    bottom: 12px;
    width: 24px;
    height: 22px;
    path {
      fill: ${({ suitColor }) => suitColor};
    }
  }
`
